export const GET_PENDING_COMPLAINTS = "GET_PENDING_COMPLAINTS";
export const GET_PENDING_COMPLAINTS_SUCCESS = "GET_PENDING_COMPLAINTS_SUCCESS";
export const GET_PENDING_COMPLAINTS_FAIL = "GET_PENDING_COMPLAINTS_FAIL";

export const GET_PENDING_COMPLAINTS_LABHAZIR = "GET_PENDING_COMPLAINTS_LABHAZIR";
export const GET_PENDING_COMPLAINTS_LABHAZIR_SUCCESS = "GET_PENDING_COMPLAINTS_LABHAZIR_SUCCESS";
export const GET_PENDING_COMPLAINTS_LABHAZIR_FAIL = "GET_PENDING_COMPLAINTS_LABHAZIR_FAIL";

export const GET_INPROCESS_COMPLAINTS = "GET_INPROCESS_COMPLAINTS";
export const GET_INPROCESS_COMPLAINTS_SUCCESS =
  "GET_INPROCESS_COMPLAINTS_SUCCESS";
export const GET_INPROCESS_COMPLAINTS_FAIL = "GET_INPROCESS_COMPLAINTS_FAIL";

export const GET_INPROCESS_COMPLAINTS_LABHAZIR = "GET_INPROCESS_COMPLAINTS_LABHAZIR";
export const GET_INPROCESS_COMPLAINTS_LABHAZIR_SUCCESS =
  "GET_INPROCESS_COMPLAINTS_LABHAZIR_SUCCESS";
export const GET_INPROCESS_COMPLAINTS_LABHAZIR_FAIL = "GET_INPROCESS_COMPLAINTS_LABHAZIR_FAIL";

export const GET_RESOLVED_COMPLAINTS = "GET_RESOLVED_COMPLAINTS";
export const GET_RESOLVED_COMPLAINTS_SUCCESS =
  "GET_RESOLVED_COMPLAINTS_SUCCESS";
export const GET_RESOLVED_COMPLAINTS_FAIL = "GET_RESOLVED_COMPLAINTS_FAIL";

export const GET_RESOLVED_COMPLAINTS_LABHAZIR= "GET_RESOLVED_COMPLAINTS_LABHAZIR";
export const GET_RESOLVED_COMPLAINTS_LABHAZIR_SUCCESS =
  "GET_RESOLVED_COMPLAINTS_LABHAZIR_SUCCESS";
export const GET_RESOLVED_COMPLAINTS_LABHAZIR_FAIL = "GET_RESOLVED_COMPLAINTS_LABHAZIR_FAIL";

export const ASSIGN_COMPLAINT = "ASSIGN_COMPLAINT";
export const ASSIGN_COMPLAINT_SUCCESS = "ASSIGN_COMPLAINT_SUCCESS";
export const ASSIGN_COMPLAINT_FAIL = "ASSIGN_COMPLAINT_FAIL";
